import { render, staticRenderFns } from "./CheckboxToggle.vue?vue&type=template&id=2c60abaf&"
import script from "./CheckboxToggle.vue?vue&type=script&lang=js&"
export * from "./CheckboxToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports